import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getFormatedPrice } from '../../../helpers/getFormatedPrice';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Extra } from '../../Common/Extra';
import { Heading } from '../../Common/Heading';
import { Selector, SelectorItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  smartRelease: number | 'no',
  smartReleasePrice: number,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (smartRelease, smartReleasePrice, send) => () => {
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      smartRelease,
      smartReleasePrice,
    },
  });
};

export const SmartRelease = () => {
  const [state, send] = useService(productBuilderMachine);
  const {
    smartRelease: smartReleaseAddonProducts,
    custom: { smartRelease },
  } = state.context;

  if (
    isCurrentState('smartRelease', state) &&
    smartReleaseAddonProducts.length === 0
  ) {
    const additionalMessage = `window.smartRelease is empty`;
    throwError(state, additionalMessage);
  }

  return (
    <SectionContent>
      <Heading>Smart Release</Heading>
      <Selector>
        {smartReleaseAddonProducts.map(product => {
          const {
            title = '',
            first_available_variant: { id, price },
          } = product;

          return (
            <SelectorItem
              isSelected={smartRelease === id}
              onClick={onClick(id, price, send)}
              key={id}
            >
              {title} <Extra> + {getFormatedPrice(price)} </Extra>
            </SelectorItem>
          );
        })}
        <SelectorItem
          isSelected={smartRelease === 'no'}
          onClick={onClick('no', 0, send)}
          key="no"
        >
          No, thanks
        </SelectorItem>
      </Selector>
    </SectionContent>
  );
};
